module.exports = __webpack_public_path__ + "static/img/img27.8910f00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img27.png
// module id = /jpj
// module chunks = 1